import {
  REQUEST_SHORT_URL,
  RECEIVE_SHORT_URL,
} from 'Config/types';

export default function bitlyReducer(state = {}, { type = '', payload } = {}) {
  switch (type) {
    case REQUEST_SHORT_URL: {
      return { ...state, isFetchingUrl: true };
    }
    case RECEIVE_SHORT_URL: {
      const { shortened } = payload;
      return { ...state, shortened, isFetchingUrl: false };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/bitly.js